export default {"src":"/_next/static/media/location-select.977b717e.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};